import { render, staticRenderFns } from "./alterar-senha.vue?vue&type=template&id=68a81a0e"
import script from "./alterar-senha.vue?vue&type=script&lang=js"
export * from "./alterar-senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports